/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".badge-secondary[_ngcontent-%COMP%]:focus, .badge-secondary[_ngcontent-%COMP%]:hover{color:#fff}"];
export { styles as styles };
